import axios from 'axios'
import * as i18n from '@/setup/i18nSetup.js'

const getDefault = () => {
  return {
    saveToDevice: false,
    contactInformation: {
      companyName: '',
      organizationNumber: '',
      fullName: '',
      address: '',
      country: 'SE',
      postalCode: '',
      city: '',
      contactPerson: '',
      email: '',
      mobile: '',
      mobileUnformatted: '',
      customer: null
    },
    paymentMethod: 'none',
    netsUrl: null,
    cartId: null,
    orderId: null,
    transactionId: null,
    paymentStatus: 'unpaid',
    receiptUrl: null,
    orderActivated: false
  }
}

export default {
  namespaced: true,
  state: Object.assign({}, getDefault()),
  mutations: {
    SAVE(state, data) {
      state.contactInformation = data
    },
    TOGGLE_SAVE_TO_DEVICE(state) {
      state.saveToDevice = !state.saveToDevice
    },
    SET_CUSTOMERS(state, data) {
      state.customers = data
    },
    SET_PAYMENT_METHOD(state, data) {
      state.paymentMethod = data
    },
    SET_SUCCESS_PAYMENT_STATE(state, data) {
      state.netsUrl = data.url
      state.cartId = data.cartId
      state.orderId = data.orderId
    },
    SET_SUCCESS_ACTIVATE_STATE(state, data) {
      state.orderActivated = true
      state.receiptUrl = data
      state.paymentStatus = 'success'
    },
    SET_PAYMENT_STATUS(state, data) {
      state.paymentStatus = data
    },
    RESET_TRANSACTION_STATES(state) {
      state.paymentStatus = 'unpaid'
      state.cartId = null
      state.receiptUrl = null
      state.netsUrl = null
      sessionStorage.removeItem('orderPlaced')
      state.orderId = null
      state.transactionId = null
    },
    RESET_PAY_STATES(state) {
      state.paymentStatus = 'unpaid'
      sessionStorage.removeItem('orderPlaced')
      state.orderActivated = false
    },
    RESET_STATE_ALL(state) {
      const defaultVal = getDefault()

      if (state.saveToDevice) {
        defaultVal.saveToDevice = state.saveToDevice
        defaultVal.contactInformation = state.contactInformation
      }

      state = Object.assign(state, defaultVal)
    },
    RESET_CART(state) {
      sessionStorage.removeItem('orderPlaced')
      state.netsUrl = null
      state.cartId = null
      state.orderId = null
      state.receiptUrl = null
      state.orderActivated = false
      state.transactionId = null
    },
    SET_TRANSACTION_ID(state, data) {
      state.transactionId = data
    }
  },
  actions: {
    activateOrder({ state }) {
      return axios({
        url:
          process.env.VUE_APP_W2P_API_BASE_URL +
          '/orders/activate/' +
          state.orderId,
        method: 'patch'
      })
    },
    buildContactInfo({ state, rootState, rootGetters }) {
      const countryNames = {
        SE: 'Sweden',
        DK: 'Denmark'
      }

      const contactInfo = {
        address: {
          country: countryNames[rootState.market],
          countryCode: rootState.market,
          city: state.contactInformation.city,
          street: state.contactInformation.address,
          zipcode: state.contactInformation.postalCode.replace(' ', '')
        },
        email: state.contactInformation.email
      }

      if (state.contactInformation.mobile.trim().length > 0) {
        contactInfo.mobile = state.contactInformation.mobile
      }

      if (rootGetters.isBusinessUser) {
        contactInfo.company = {
          contactPerson: state.contactInformation.contactPerson,
          name: state.contactInformation.companyName,
          organizationNumber: state.contactInformation.organizationNumber
        }
      } else {
        contactInfo.firstName = state.contactInformation.fullName
      }

      return contactInfo
    },
    buildSenderInfo({ rootState }) {
      const address = rootState.letter.address
      const info = {
        addressLineOne: address.senderInformation.name,
        addressLineTwo: address.senderInformation.addressOptional || '',
        country: address.senderInformation.country,
        street: address.senderInformation.address,
        zipcode: address.senderInformation.postalCode.replace(' ', ''),
        city: address.senderInformation.city
      }

      if (address.senderInformation.addressOptional.trim() > 0) {
        info.addressLineTwo = address.senderInformation.addressOptional
      }

      return info
    },
    // FIXME: manual address is not ready in place order yet.
    placeOrder: async ({ state, rootState, rootGetters, dispatch }) => {
      const cart = rootState.cart
      const upload = rootState.letter.upload
      const delivery = rootState.letter.delivery
      const address = rootState.letter.address

      const paymentMethods = {
        creditCard: 'CARD',
        directTransfer: 'CARD',
        invoice: 'INVOICE'
      }

      const data = {
        addressesFolderId: address.id,
        originalAddressFileName: address.fileName,
        addressType: address.addressType,
        targetType: address.targetType,
        paymentMethod: rootGetters.isBusinessUser
          ? paymentMethods[state.paymentMethod]
          : 'CARD',
        productId: upload.productId,
        prefacePage: upload.letterOptions.includePreface,
        deliveryDate: delivery.deliveryDate,
        deliveryId: delivery.deliveryId,
        name:
          upload.mailoutName.trim().length > 0
            ? upload.mailoutName
            : i18n.i18n.t(cart.productDelivery.productName),
        material: upload.folderId,
        country: rootState.market,
        language: rootState.lang,
        senderInfo: await dispatch('buildSenderInfo'),
        contactInfo: await dispatch('buildContactInfo'),
        redirectUrl: '#/letter/pay/approve-status',
        version: 'v2',
        customerNumber:
          rootGetters.isBusinessUser && state.contactInformation.customer
            ? state.contactInformation.customer.customerNumber
            : null
      }

      return axios({
        url: process.env.VUE_APP_W2P_API_BASE_URL + '/orders/placeOrder',
        method: 'post',
        headers: {
          authorization: rootState.accessToken
        },
        data
      })
    },
    getPaymentMethods: async ({ rootState }) => {
      return axios({
        url: `${process.env.VUE_APP_W2P_API_BASE_URL}/orders/paymentmethods/${rootState.market}`,
        method: 'get'
      })
    }
  }
}
